"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4052],{

/***/ 4052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WhyHeycater; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/benefit1.png
/* harmony default export */ var benefit1 = ({"src":"/_next/static/media/benefit1.12e07044.png","height":206,"width":259,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAARVBMVEVMaXH5/N/q6s38/+r7/9+rsJ7z9daws53Lz7W9wKnw/+Ly9diXmogAAAD9/+KAgnOanIr9/+fm6Mvi58n//+3BxK3t79XpdrdsAAAAFHRSTlMAjyRWSB0y+vz5EqZjCuuH/K986vMoERYAAAAJcEhZcwAALiMAAC4jAXilP3YAAAA0SURBVHicBcEHAsAgCACxwwV0aSv6/6c2AWq5KkDx5dpveMOHzgQSphoZ0rPNzgNo8jX4ASZcAW9hWUlBAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/benefit2.png
/* harmony default export */ var benefit2 = ({"src":"/_next/static/media/benefit2.646dcb9c.png","height":206,"width":259,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAQlBMVEVMaXH5+efm6s7EybL+/+X//+eqr5zo7NH//+22u6X//+3M0Lj//+gpLy/Z4cP//+qHjH1/hHgADQ3P1LvO07vc4cf5JLQ0AAAAFHRSTlMAFev9SY/6+i75r6Z8KyJWM4wT6komrSkAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAzSURBVHicBcEBAoAgCACxs1BAK7Xg/19tA4rIugHRTN8vdPUzvgdqNm8xwQ6NGAWwehn8KwUBku6IVuYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/benefit3.png
/* harmony default export */ var benefit3 = ({"src":"/_next/static/media/benefit3.21bc265d.png","height":206,"width":259,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAS1BMVEVMaXH099z////7/97X2r/2+dr5+ezo6872/NvR1Lv3+93//+f5/N36++T9/+Gfoo7O0rfMzK6xtJ99fW///+q9v6nX2sAAAAn//+0mNcRrAAAAGHRSTlMA/gFH/IQU+C79ka/r/qZr9CNgOVZ07hzzFTwgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAANUlEQVR4nAXBCQKAIAgAwbVQwA67VP7/0maA8rR3AquqXx3YQlzGDTXUJX1gexzpLCxYzgY/L2ABoRffhSUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/WhyHeycater.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 0px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  ",
        " {\n    justify-content: start;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 26.88px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  width: fill-available;\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 23.52px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: start;\n  gap: ",
        "px;\n  flex-direction: column;\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 510px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  flex: 1 1 0px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 47px;\n  padding: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 36px;\n  font-weight: 700;\n  line-height: 62.1px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26.88px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ",
        ";\n  flex-direction: column;\n  gap: 48px;\n  ",
        " {\n    flex-direction: row;\n    width: 1108px;\n    padding: 40px 0;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}









function WhyHeycater() {
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhyHeycaterLeftBox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: t("whyHeycater.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            my: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                children: t("whyHeycater.subtitle")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#qf-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                    variant: "primary",
                                    children: t("whyHeycater.cta")
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhyHeycaterRightBox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitCard, {
                            image: benefit1,
                            title: t("weAreHeycater.card1.title"),
                            subtitle: t("weAreHeycater.card1.subtitle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitCard, {
                            image: benefit2,
                            title: t("weAreHeycater.card2.title"),
                            subtitle: t("weAreHeycater.card2.subtitle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitCard, {
                            image: benefit3,
                            title: t("weAreHeycater.card3.title"),
                            subtitle: t("weAreHeycater.card3.subtitle")
                        })
                    ]
                })
            ]
        })
    });
}
function BenefitCard(param) {
    var image = param.image, title = param.title, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    priority: true,
                    src: image,
                    width: 75,
                    height: 65,
                    quality: 100
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                        mb: 2,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: subtitle
                    })
                ]
            })
        ]
    });
}
var WhyHeycaterLeftBox = styled_components_browser_esm["default"].div(_templateObject());
var ButtonContainer = styled_components_browser_esm["default"].div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Head = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject2());
var ImageBox = styled_components_browser_esm["default"].div(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Subtitle = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject4());
var Card = styled_components_browser_esm["default"].div(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var WhyHeycaterRightBox = styled_components_browser_esm["default"].div(_templateObject6());
var StyledButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.spacing(1.5, 3);
});
var Title = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject8());
var Paragraph = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject9());
var Wrapper = styled_components_browser_esm["default"].div(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var Container = styled_components_browser_esm["default"].div(_templateObject11());


/***/ })

}]);